<template lang="html">
  <div id='home-footer' class="row">
    <div class="footer-background">
    <div class="col-lg-12 hiden-footer-menu-mobile">
      <div class="row">
        <div class="col-lg-3 logo text-right">
          <router-link :to="{name:'home', params:{ lang: lang}}"><img class="img-responsive" src="../assets/img/icons/white-logo.svg" width="640" height="360" alt="Logo"></router-link>
          <div class="logo-ballon-small">
            <!-- <img class="img-responsive" src="../assets/img/icons/logo-ballon.svg" alt="Logo"> -->
          </div>
        </div>
        <div class="col-lg-9  text-center">
          <div class="logo-ballon-big">
            <!-- <img class="img-responsive" src="../assets/img/icons/logo-ballon.svg" alt="Logo"> -->
          </div>
          <div class="header-menu-links">
            <span class="header-links text-left">
              <router-link :to="{name:'registered-vets', params:{ lang: lang}}">{{translation.doctor.doctors}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'about-us', params:{ lang: lang}}">{{translation.aboutUs.about}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'privacy-policy', params:{ lang: lang}}">{{translation.button.gdprTitle}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'general-terms', params:{ lang: lang}}">{{translation.generalTerms.button}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'support', params:{ lang: lang}}">{{translation.header.contacts}}</router-link>
            </span>
            <div class="login-registration-links">
              <span class="header-links text-center login-text">
                <router-link :to="{name:'login', params:{ lang: lang}}">{{translation.header.login}}</router-link>
              </span>
              <span class="header-links text-center registration-text">
                <router-link :to="{name:'registration', params:{ lang: lang}}">{{translation.header.registration}}
                </router-link>
              </span>
            </div>

          </div>
          <div class="row">
            <div class="cl-sm-12 text-center">
              <div class="followUs-icons row">
                <div class="links followUs">
                  {{translation.menu.followUs}}
                </div>
                <div class="text-right col-xs-6">
                  <a href="https://web.facebook.com/My-Electronic-Pet-Passport-100922267942159" target="_blank"><img class="img-responsive" src="../assets/img/icons/fb-white.svg" width="640" height="360" alt="Facebook"></a>
                </div>
                <div class="text-left col-xs-6">
                  <a href="https://www.youtube.com/channel/UCQslSWc0OMv5CabwZ5d8McQ" target="_blank"><img class="img-responsive" width="640" height="360" src="../assets/img/icons/YouTube_social_dark_circle_(2017).svg" alt="YouTube"></a>
                </div>
              </div>
              <div class="copyRights text-center">
                &copy;
                {{date}}
                {{translation.footer.allRights}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeFooter',
  data(){
    return{
      translation: message,
      date: null,
      lang: window.lang
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.date = new Date().getFullYear();
  }
}
</script>

<style lang="css" scoped>
#home-footer{
  position: relative;
  background-image: url('../assets/img/backgrounds/futyr.webp');
  background-repeat:no-repeat;
  max-width:inherit;
  min-height: 100%;
  background-position: center;
  background-size: cover;
  margin-top: 2em;
  padding: 2em;
  padding-top: 11em;
  padding-bottom: 11em;
}

@font-face {
  font-family: 'Montserrat-Black';
  src: url("../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#home-footer .header-links a:hover{
  text-decoration: none;
  color: #FED154;
}
#home-footer .header-links a{
  color: #FFF;
}
#home-footer .header-links{
  display: inline-block;
}
#home-footer .header-links{
  font-family: "Montserrat-Black", sans-serif;
  margin-right: 1em;
  color: #FFF;
}
#home-footer .login-registration-links{
  display: inline-block;
  margin-left: 3em;
}
#home-footer .registration-text a{
  color: #3057B0;
}
#home-footer .registration-text{
  background: #FDD84C;
  border: 2px solid #FDD84C;
  padding: .3em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-radius: 5em;
}
#home-footer .registration-text a:hover{
  color: #FFF;
}
#home-footer .login-text a {
  padding: .4em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-radius: 5em;
  border: 2px solid #FFF;
  color: #FFFFFF;
}
.followUs-icons img{
  margin-top: 1em;
  width: 3em;
}
.followUs-icons{
  color: #fff;
  font-weight: bold;
  margin-top: 2em;
}
#home-footer .header-menu-links{
  margin-top: 2em;
}
#home-footer .header-menu-links .header-links{
  margin-right: 1em;
  display: inline-block;
}
#home-footer .header-menu-links .login-registration-links{
  margin-left: 2em;
  display: inline-block;
}
#home-footer .copyRights{
  color: #fff;
  margin-top: 2em;
}
@media (max-width: 1024px) {
  #home-footer{
    background-image: url('../assets/img/backgrounds/01-home-–-36.jpg');
  }
  #home-footer .header-menu-links .header-links{
    display: block;
    text-align: center;
    margin-bottom: 1em;
    margin-right: 0;
  }
  #home-footer .header-menu-links .login-registration-links{
    display: block;
    text-align: center;
    margin: 0;
    margin-bottom: 1em;
  }
  #home-footer .logo{
    margin: 0 auto;
    width: 10em;
    margin-top: 4em;
  }
  #home-footer .followUs {
    color: #fff;
  }
}
</style>
